export default __webpack_public_path__ + "static/media/@melissaverli1.79335b2f.jpg";